import { createFileRoute } from '@tanstack/react-router'
import { ImportsListPage } from '../../../components/imports/ImportsListPage'

export const Route = createFileRoute('/$org/imports/')({
    component: ImportsListRoute,
})

function ImportsListRoute() {
    return <ImportsListPage />
}
